import styled, { css } from 'styled-components/macro'

export const AnimationContainer = styled.div`
  position: absolute;
  overflow: hidden;
  aspect-ratio: 16/9;

  @media (max-width: 1024px) {
    aspect-ratio: 256/267;
  }
  @media (max-width: 700px) {
    aspect-ratio: 256/326;
  }
  @media (max-width: 520px) {
    aspect-ratio: 115/157;
    aspect-ratio: 112/176;
  }

  min-height: 100%;
  min-width: 100%;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  width: auto;

  img {
    position: absolute;
  }

  @keyframes blinking {
    0% {
      opacity: 0;
    }
    68% {
      opacity: 1;
    }
    70% {
      opacity: 0;
    }
    88% {
      opacity: 1;
    }
    90% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`
export const Background = styled.img`
  width: 100%;
  bottom: 0;
`
export const Figures = styled.img<{ $isPageVisible: boolean }>`
  width: 100%;
  opacity: 0;
  transition: opacity 1s;
  transition-delay: 0.8s;

  @media (max-width: 1024px) {
    top: 0.5%;
  }
  @media (max-width: 700px) {
    top: 18.4%;
  }
  @media (max-width: 520px) {
    top: auto;
    bottom: 57%;
  }
  ${(props) => (props.$isPageVisible ? 'opacity: 1' : '')}
`
export const Woman = styled.img<{ $isPageVisible: boolean }>`
  width: 100%;
  bottom: 0;
  opacity: 0;
  ${(props) =>
    props.$isPageVisible
      ? css`
          animation: blinking 1s steps(1, end) forwards;
          animation-iteration-count: 1;
        `
      : ''}
`
